import React, { useState } from "react";
import { MainChat } from "./MainChat/MainChat";
import { ChatFooter } from "./ChatFooter/ChatFooter";
import { ICreateMessageResponse } from "./Types/Type";
import { API_CENTER } from "../../services/api/api";
import { useAppDispatch, useAppSelector } from "../../store/reduxHooks";
import { REQUEST_CHAT_ADD_MESSAGE } from "../../store/slice/requestAppSlise/requestAppSlise";
import { SELECT_REQUEST_CHAT_DATA } from "../../store/selectors/requestAppSelector";

import classes from "./Chat.module.css";

//чат
export function Chat(): JSX.Element {
  const API = new API_CENTER();
  const [spinData, setSpinData] = useState(false);
  const dispatch = useAppDispatch();
  const data = useAppSelector(SELECT_REQUEST_CHAT_DATA);
  const formChatData = new FormData();
  function sendTomessege(message: {
    chatInputText?: string;
    file?: { file: File };
  }): void {
    setSpinData(true);
    if (message.chatInputText) {
      formChatData.append("text", message.chatInputText);
    }
    if (message?.file) {
      formChatData.append("file", message.file.file);
    }
    API.GET_API(`chat/${data.id}`, "POST", formChatData).then(
      (response: ICreateMessageResponse) => {
        if (response.success) {
          dispatch(REQUEST_CHAT_ADD_MESSAGE(response.data));
          formChatData.delete("file");
          formChatData.delete("text");
          setSpinData(false);
        }
        if (!response.success) {
          setSpinData(false);
          formChatData.delete("file");
          formChatData.delete("text");
        }
      },
    );
  }

  function deleteFile(): boolean {
    try {
      formChatData.delete("file[0]");
      return true;
    } catch (err) {
      return false;
    }
  }

  return (
    <div className={classes.chat}>
      <MainChat chat={data.messages} spinData={spinData} />
      <ChatFooter sendToMessage={sendTomessege} delliteFile={deleteFile} />
    </div>
  );
}
